import styled, { css } from 'styled-components'

import { Button } from '@Components/Button'
import { StyledSmallButton } from '@Components/BuyButton/styledElements'
import { SVGIcon } from '@Components/Icons'
import { ProductTitle } from '@Components/Product/Tile/styledElements'
import { ContainerSlider } from '@Components/Slider/ContainerSlider'
import { up } from '@Globals/Style/breakpoints'

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyLighter};
`

export const Icon = styled.div(({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 50px;
  min-height: 50px;
  border-radius: 50%;
  border: 2px solid ${theme.colors.primary};
  padding: 12px;
  margin-bottom: 5px;
`)

export const FreeShippingNotice = styled.div`
  padding: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyLighter};
  text-align: center;
`

export const CTAWrapper = styled.div(({ theme }) => css`
  ${up('tablet')} {
    flex-direction: column;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column-reverse;
  padding-bottom: ${theme.padding.phablet};
  border-bottom: 1px solid ${theme.colors.greyLighter};

  ${FreeShippingNotice} + & {
    margin-top: ${theme.padding.desktop};
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  ${up('tablet')} {
    flex-direction: row;

    > * {
      flex: 1 1 50%;
      max-width: 50%;
    }

    & > :first-child {
      margin-right: 5px;
    }

    & > :last-child {
      margin-left: 5px;
    }
  }
`)

export const SmallPersonalizationButton = styled(Button)`
  margin-bottom: 0;
  align-self: center;
  min-height: 31px;

  & span {
    display: flex;
    align-items: center;
  }

  ${StyledSmallButton}
`

export const CrossSellContainer = styled.section(() => css`
  margin: 20px 0 10px;

  ${up('tablet')} {
    margin-bottom: 20px;
  }

  ${ProductTitle} {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    overflow: hidden;
  }
`)

export const CrossSellHeader = styled.h3(({ theme }) => css`
  color: ${theme.colors.greyDark};
  text-transform: none;
  text-align: center;
  font-size: 1.125rem;
  font-weight: bold;
  margin-bottom: 10px;
`)

export const InlineIcon = styled(SVGIcon)`
  display: inline-block;
  vertical-align: middle;
  margin-top: -.2em;
`

export const ErrorMessages = styled.ul(({ theme }) => css`
  color: ${theme.colors.red};
  padding: 1.5em 1em 1.5em 2.5em;

  li {
    list-style: disc;
  }

  * {
    color: inherit;
  }

  &:empty {
    display: none;
  }
`)

export const StyledContainerSlider = styled(ContainerSlider)`

`

export const StaticUpsellWrapper = styled.div(({ theme }) => css`
  display: flex;
  width: 100%;
  gap: ${theme.padding.phablet};
  justify-content: center;
`)
